import makeStyles from '@mui/styles/makeStyles';

export const useAlarmsStyles = makeStyles((theme) => ({
    dialogContent: {
        maxHeight: 'calc(100vh - 230px)',
    },
    modalBackground: {
        backgroundColor: theme.palette.mode === 'light' ? '#ffffff' : '#313233',
    },
    label: {
        color: theme.palette.mode === 'light' ? '#626466' : '#FFFFFF',
        fontSize: 14,
        paddingBottom: 5,
        paddingLeft: 5,
    },
    modalBody: {
        color: theme.palette.default.contrastBackground,
        backgroundColor: theme.palette.default.contrastText,
    },
    header: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(2, 2, 2),
        color: theme.palette.patientCard.main.color,
    },
    body: {
        padding: theme.spacing(2, 4, 3),
        maxHeight: 'calc(100vh - 140px - 46px -46px)',
    },
    chipText: {
        color: theme.palette.primary.contrastTextAlarmChip,
    },
    noAlarmsBlock: {
        background: theme.palette.background.infoNote,
        fontSize: '18px',
        color: theme.palette.notes.accentText2,
        display: 'flex',
        marginTop: '20px',
        padding: '14px',
        borderRadius: '3px',
        boxShadow: theme.shadows[3],
    },
    alarmGroupBadge: {
        display: 'flex',
        alignItems: 'center',
        background: 'aliceblue',
        color: 'black',
        padding: '2px 10px 3px',
        borderRadius: '8px',
        float: 'right',
        marginRight: 5,
    },
    alertGroupName: {
        display: 'flex',
        height: '40px',
        paddingTop: '4px',
        paddingBottom: '4px',
        marginBottom: '4px',
        color: theme.palette.mode === 'light' ? '#494B4C' : '#fff',
    },
    alertGroupNameText: {
        display: 'inline-block',
        marginLeft: '20px',
        width: 'calc(100% - 90px)',
        lineHeight: '36px',
    },
    alertGroupNameIco: {
        position: 'relative',
        left: '10px',
        top: '6px',
    },
    alarmGroupExpandBtn: {
        float: 'right',
        fontSize: '30px',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
    },
    alertGroup: {
        paddingRight: '10px',
        marginBottom: '10px',
        borderRadius: 8,
        backgroundColor: theme.palette.background.paper,
    },
    alertGroupsList: {
        marginTop: '10px',
        overflow: 'auto',
    },
    alertAlarm: {
        padding: '7px',
        marginBottom: 10,
        marginLeft: 10,
        borderRadius: 6,
        backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#313233',
    },
    alarmHeader: {},
    alarmHeaderText: {
        fontSize: '1.25rem',
        fontWeight: 500,
        display: 'inline',
    },
    alarmHeaderIco: {
        position: 'relative',
        float: 'right',
        background: '#252525',
        borderRadius: '3px',
        paddingTop: '3px',
        paddingLeft: '3px',
        paddingRight: '3px',
        cursor: 'help',
    },
    alarmBodyAdditionalDesc: {
        fontStyle: 'italic',
        padding: '8px 10px',
        color: 'silver',
    },
    alarmBodyExpireDate: {
        display: 'inline-block',
        padding: '6px 8px',
        background: 'silver',
        marginTop: '10px',
        borderRadius: '3px',
        fontStyle: 'italic',
    },
    btnRemove: {},
    alarmRemoveBtn: {
        position: 'relative',
        display: 'inline-block',
        float: 'right',
        bottom: '-8px',
    },
    alertButton: {
        width: '100%',
        margin: 2,
    },
    alertStatus: {
        backgroundColor: '#999 !important',
    },
    blockColor: {
        width: 15,
        height: '100%',
        borderRadius: 4,
        marginLeft: 8,
        backgroundColor: theme.palette.mode === 'light' ? '#e2e2e2' : '#434343',
    },
    divRow: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'center',
    },
}));